<template>
  <div
    :id="`itemexpander-${item.jsonid}`"
    :ref="`itemexpander-${item.jsonid}`"
    class="item-main"
    :class="{ 'item-active': dropdown }"
    @click="toggleExpand"
  >
    <div class="item-title">
      <i v-if="isTransfer" class="icon-transfer glyph-lg mr-3 vtd-icon-4 vtd-align-middle"></i>
      <span v-else v-html="returnHeadingIcon"></span>
      <span>{{
        isTransfer 
          ? 'TRANSFER' 
          : (item.tour_details && item.tour_details.tour_style
            ? item.tour_details.tour_style.toUpperCase()
            : item.tourtype
              ? item.tourtype.toUpperCase()
              : item.jsontype.toUpperCase())
      }}</span>
    </div>

    <!-- This will be hidden on mobile devices -->
    <div class="item-main-desktop">
      <template v-if="isTransfer">
        <h6>{{ item.cityfrom }} - {{ item.cityto }}</h6>
        <p>with {{ item.operator }}</p>
      </template>
      <template v-else-if="item.brickid === '1' || item.brickid === '2'">
        <h6>For {{ item.duration }}</h6>
        <p>with {{ item.operator }}</p>
      </template>
      <template v-else-if="item.brickid === '3'">
        <h6>For {{ item.duration }}</h6>
      </template>
      <template v-else-if="item.brickid === '4'">
        <h6>{{ item.tourname }}</h6>
        <p>with {{ item.operator }}</p>
      </template>
      <template v-else-if="item.brickid === '5'">
        <h6>Operated by {{ item.operator }}</h6>
      </template>
      <template v-else-if="item.jsontype === 'rail'">
        <h6>{{ item.cityfrom }} - {{ item.cityto }}</h6>
        <p>with {{ item.operator }}</p>
      </template>
    </div>

    <!-- This will be hidden on mobile devices -->
    <div class="item-main-desktop">
      <template v-if="isTransfer">
        <h6>{{ item.request1 || '' }}</h6>
      </template>
      <template v-else-if="item.brickid === '1'">
        <h6>Embark {{ item.cityfrom }}</h6>
        <p v-if="fil === 'M'">
          Disembark {{ item.cityto }} on {{ item.enddate }}
        </p>
      </template>
      <template v-else-if="item.brickid === '2' && item.cityfrom">
        <h6>Departing from {{ item.cityfrom }}</h6>
        <p v-if="fil === 'M'">
          Tour ends in {{ item.cityto }} on {{ item.enddate }}
        </p>
      </template>
      <template v-else-if="item.brickid === '4'">
        <h6>{{ item.cityfrom }}</h6>
        <p v-if="item.cityto">
          Ends in {{ item.cityto }}
        </p>
      </template>
      <template v-else-if="item.brickid === '5'">
        <h6>{{ item.cityfrom }}</h6>
      </template>
      <template v-else-if="item.jsontype === 'rail'">
        <h6>Departing at {{ item.deptime }}</h6>
        <p>Arriving at {{ item.arrtime }} {{item.arrday? `(${item.arrday})` : ""}}</p>
      </template>
    </div>

    <div class="toggle">
      <span v-if="!dropdown">+</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
      showIcon: true,
    };
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
  computed: {
    ...mapGetters({ fil: "booking/getFil" }),
    isTransfer() {
      return this.item && 
             this.item.meetmsg &&
             this.item.meetmsg.length > 0 &&
             this.item.tourtype && 
             this.item.tourtype.includes("LOCAL TOUR") &&
             this.item.meetmsg[0].title === "Transfer Information";
    },
    returnHeadingIcon() {
      // BAsed on the type of tour which is in the brick id return the correct image code for the heading bar
      if (this.item.brickid === "1") {
        return '<i class="icon-cruise vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("CRUISE HOLIDAY")
      ) {
        return '<i class="icon-cruise vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("SAFARI")
      ) {
        return '<i class="icon-safari vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("GROUP")
      ) {
        return '<i class="icon-small_group_tour vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("MULTI CENTRE")
      ) {
        return '<i class="icon-trail_notes vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        (this.item.brickid === "2" && this.item.tourtype.includes("RAIL")) ||
        this.item.jsontype === "rail"
      ) {
        return '<i class="icon-rail vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("TRAVEL PASS")
      ) {
        return '<i class="icon-travel_pss vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("VOLUNTEER PROJECT")
      ) {
        return '<i class="icon-volunteer_project vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("WORK ABROAD")
      ) {
        return '<i class="icon-work_abroad vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("SKILL")
      ) {
        return '<i class="icon-learn_a_skill vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      } else if (
        this.item.brickid === "2" &&
        this.item.tourtype.includes("WILDERNESS")
      ) {
        return '<i class="icon-wilderness_experience vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.tourtype.includes("ATTRACTION TICKETS")) {
        return '<i class="icon-event_tickets vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.brickid === "2" && this.item.tourtype.includes("ADVENTURE TOUR")) {
        return '<i class="icon-trail_notes vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.brickid === "2" && this.item.tourtype.includes("ESCORTED TOUR")) {
        return '<i class="icon-escorted_tour vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.brickid === "2" && this.item.tourtype.includes("CRUISE LAND TOUR")) {
        return '<i class="icon-cruise vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.brickid === "2") {
        return '<i class="icon-accomodation vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.brickid === "3") {
        return '<i class="icon-private_tour vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (this.item.brickid === "4" && this.item.tourtype.includes("EVENT")) {
        return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>theaters</span></i>';
      } else if (
        this.item.brickid === "4" &&
        this.item.tourtype.includes("LOCAL TOUR")
      ) {
        // check if local tour_style exists
        if (this.item.tour_details && this.item.tour_details.tour_style) {
          if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("CRUISE") ||
            this.item.tour_details.tour_style.toUpperCase().includes("FERRY")
          ) {
            return '<i class="icon-cruise vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("GROUP")
          ) {
            return '<i class="icon-small_group_tour vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("RAIL")
          ) {
            return '<i class="icon-rail vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("SCENIC FLIGHT")
          ) {
            return '<i class="icon-flight vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("ATTRACTION TICKETS")
          ) {
            return '<i class="icon-event_tickets vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("COACH")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>directions_bus</span></i>';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("CYCLING")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>pedal_bike</span></i>';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("SKI LIFT")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>downhill_skiing</span></i>';
          } else if (
            this.item.tour_details.tour_style.toUpperCase().includes("SHUTTLE")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>airport_shuttle</span></i>';
          } else if (
            this.item.tour_details.tour_style
              .toUpperCase()
              .includes("ARRIVAL PACK")
          ) {
            return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>inventory</span></i>';
          } else if (this.item.tour_details.tour_style
              .toUpperCase()
              .includes("TRANSFER")){
            return '<i class="icon-transfer glyph-lg vtd-icon-4 mr-3 vtd-mr-3 vtd-align-middle"></i>';
          } else {
            return '<i class="icon-local_tour vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
          }
        } else {
          return '<i class="icon-local_tour vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
        }
      } else if (this.item.brickid === "4" && this.item.tourtype === "FERRY") {
        return '<i class="icon-ferry glyph-lg pr-3"/>';
      } 
      if (
        this.item.brickid === "5" &&
        this.item.tourtype === "WEDDING PACKAGE"
      ) {
        return '<i class="icon-wedding_package vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      if (
        this.item.brickid === "5" &&
        this.item.tourtype !== "WEDDING PACKAGE"
      ) {
        return '<i class="icon-wedding_package vtd-icon-4 glyph-lg mr-3 vtd-align-middle" />';
      }
      return '<i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"><span>info</span></i>';
    },
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
      this.$emit("clicked", this.dropdown);
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
  },
};
</script>

<style lang="scss">
@import "../styles.scss";
</style>
